import { useNavigate, useLocation, useParams } from "react-router";
import { useMemo } from "react";
import { parse } from "qs";

// eslint-disable-next-line @typescript-eslint/ban-types
export function useRouter<RouteParameters = {}>() {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    return useMemo(() => {
        return {
            push: navigate,
            pathname: location.pathname,
            query: {
                ...parse(location.search, { ignoreQueryPrefix: true }),
                ...params,
            } as RouteParameters,
            location,
        };
    }, [params, location, navigate]);
}
